import React from 'react';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const resolveRawImageUrl = (content) => {
  if (content?.image?.scales?.large?.download) return content.image.scales.large.download;
  if (content?.image?.scales?.preview?.download) return content.image.scales.preview.download;
  if (content?.image?.download) return content.image.download;
  const pil = content?.preview_image_link;
  if (pil && typeof pil === 'object' && pil['@id']) {
    return `${pil['@id']}/@@images/image/larger`;
  }
  if (typeof pil === 'string') return pil;
  return null;
};

// Caminho do site, nunca o endereço do backend: no SSR o @id vem com o
// endereço interno (127.0.0.1:8080), o navegador não carrega a foto e o
// ImageFallback fixa a largura do instante da falha.
const resolveImageUrl = (content) => {
  const url = resolveRawImageUrl(content);
  return url ? flattenToAppURL(url) : null;
};

/**
 * Bloco "Imagem Principal" — espelho do preview_image_link do contexto.
 *
 * O bloco em si não armazena imagem própria. Lê (e o Edit escreve) direto
 * em content.preview_image_link e content.preview_caption_link — os mesmos
 * campos do Painel de Controle (Imagem de Pré-visualização).
 *
 * Volto passa o conteúdo atual em `metadata` (no View público) ou
 * `properties` (no Edit). Suportamos os dois.
 */
const ImagemPrincipalView = ({ metadata, properties }) => {
  const content = metadata || properties || {};
  const imageUrl = resolveImageUrl(content);
  const caption = content?.preview_caption_link;

  if (!imageUrl) {
    return (
      <p className="ag-news-view__figure-empty">
        Selecione uma imagem na barra lateral.
      </p>
    );
  }

  return (
    <figure className="ag-news-view__figure">
      <img src={imageUrl} alt={caption || content?.title || ''} loading="eager" />
      {caption && (
        <figcaption className="ag-image-block__caption">{caption}</figcaption>
      )}
    </figure>
  );
};

ImagemPrincipalView.propTypes = {
  metadata: PropTypes.object,
  properties: PropTypes.object,
};

export default ImagemPrincipalView;
